import { setupI18n, MessageDescriptor } from '@lingui/core'

export const i18n = setupI18n({})

export const _ = (msg: MessageDescriptor) => i18n._(msg)
